import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationSelectionViewModelType from '@/ViewModels/Controls/PrincipalHistorizationSelectionViewModel';
import LabelType from '@/Controls/Label';
import CheckBoxType from '@/Controls/CheckBox';

export default class PrincipalHistorizationSelection extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private CheckBox = ComponentManager.getControl<typeof CheckBoxType>('CheckBox');
    private jQueryControl: JQuery;
    private label: LabelType;
    private checkbox: CheckBoxType;

    public constructor(private viewModel: PrincipalHistorizationSelectionViewModelType, private element?: JQuery) {
        super(viewModel, element);
        
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><div class="head"></div><ul class="body"></ul></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'principalhistorizationselection',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(this.jQueryControl.find('.body'), {
            principalHistorizationSelectionItems: {
                parent: this,

                items: this.viewModel.items
            }
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.head'));
        }

        if (this.viewModel.checkbox != null) {
            this.checkbox = new this.CheckBox(this.viewModel.checkbox);
            let tuple = this.checkbox.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.head'));
        }
    }
}

ComponentManager.setControl('PrincipalHistorizationSelection', PrincipalHistorizationSelection, 'RADPresentation.HTMLClient.DefaultViewExtensions');